import React, { useRef } from "react";
import {
  DatetimeChangeEventDetail,
  IonDatetime,
  IonDatetimeButton,
  IonModal,
  IonPopover,
} from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import CommonFormElement from "../../UI/CommonFormElements/CommonFormElement";
import styles from "./SelectDeliveryDate.module.scss";

interface ISelectDeliveryDate {
  isValid: boolean;
  value: string | null;
  onChange: (e: CustomEvent<DatetimeChangeEventDetail>) => void;
  deliveryDateList: string[];
  className?: string;
}

const cx = classNames.bind(styles);

const SelectDeliveryDate: React.FC<ISelectDeliveryDate> = ({
  isValid,
  deliveryDateList,
  value,
  onChange,
  className,
}) => {
  const modalRef = useRef<HTMLIonModalElement>(null);
  const { t } = useTranslation();
  return (
    <CommonFormElement label={t("Delivery date")} isValid={isValid}>
      <div className={className + " flex w-full py-[14px] px-[17px]"}>
        <IonDatetimeButton datetime="delivery_date" className={cx("dateTimeButton")} />
        {Capacitor.getPlatform() === "web" ? (
          <IonPopover keepContentsMounted={true} dismissOnSelect>
            <IonDatetime
              id="delivery_date"
              isDateEnabled={(curr) => {
                return deliveryDateList.some((el) => el === curr);
              }}
              presentation="date"
              name="delivery-date"
              value={value}
              onIonChange={onChange}
              doneText={t("Ok")}
            />
          </IonPopover>
        ) : (
          <IonModal ref={modalRef} keepContentsMounted={true}>
            <IonDatetime
              id="delivery_date"
              isDateEnabled={(curr) => {
                return deliveryDateList.some((el) => el === curr);
              }}
              presentation="date"
              name="delivery-date"
              value={value}
              onIonChange={(e) => {
                onChange(e);
                modalRef.current?.dismiss();
              }}
              doneText={t("Ok")}
            />
          </IonModal>
        )}
      </div>
    </CommonFormElement>
  );
};

export { SelectDeliveryDate };
